/**
 * Pegado de varios pagos recibidos (Zelle / Binance) desde el banco o una hoja de cálculo: una línea por pago,
 * "Nombre ; Monto ; Referencia", separados por punto y coma, tabulador o barra. Los montos aceptan 1.234,56 y 1234.56.
 */
import { parseMonto } from './montos.ts';

export interface FilaPegada {
  linea: string;
  nombre: string;
  /** Monto canónico ("155.00") si se pudo leer; si no, el texto tal cual. */
  monto: string;
  referencia: string;
  error: string | null;
}

export function interpretarPegado(texto: string): FilaPegada[] {
  return texto
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean)
    .map((linea) => {
      const partes = linea.split(/\t|;|\|/).map((p) => p.trim());
      const [nombre = '', montoTxt = '', referencia = ''] = partes;
      const monto = parseMonto(montoTxt);
      let error: string | null = null;
      if (partes.length < 3) error = 'Faltan datos: nombre ; monto ; referencia';
      else if (nombre.length < 2) error = 'Falta el nombre';
      else if (!monto || !monto.esPositivo()) error = 'Monto inválido';
      else if (referencia.replace(/[^0-9a-z]/gi, '').length < 4) error = 'Referencia muy corta (mínimo 4)';
      return { linea, nombre, monto: monto && monto.esPositivo() ? monto.toDocumento() : montoTxt, referencia, error };
    });
}
